import React from "react";

// HO-SYS brand assets. Both live at /public and are also bundled in the docker image.
export const HOSYS_LOGO_ICON = "/logo-hosys-icon.png";              // dark theme (metallic H)
export const HOSYS_LOGO_FULL = "/logo-hosys.png";                   // dark theme full lockup
export const HOSYS_LOGO_ICON_LIGHT = "/logo-hosys-white-icon.png";  // light/white bg optimized icon
export const HOSYS_LOGO_FULL_LIGHT = "/logo-hosys-white.png";       // light/white bg full lockup

/**
 * Logo component
 * - variant="mark" (default): H icon + inline "HO-SYS" wordmark. Perfect for navbars.
 * - variant="full": stacked logo (icon + HO-SYS + tagline). Perfect for login / hero.
 * - theme="dark" (default): assets tuned for dark backgrounds.
 *   theme="light": assets tuned for white / light backgrounds.
 * - showText: only applies to "mark"; when false renders just the icon.
 */
export function Logo({ className = "", showText = true, variant = "mark", theme = "dark", height }) {
  const iconSrc = theme === "light" ? HOSYS_LOGO_ICON_LIGHT : HOSYS_LOGO_ICON;
  const fullSrc = theme === "light" ? HOSYS_LOGO_FULL_LIGHT : HOSYS_LOGO_FULL;

  if (variant === "full") {
    return (
      <img
        src={fullSrc}
        alt="HO-SYS · Digital · Innovation · Solutions"
        className={`select-none ${className}`}
        draggable={false}
        style={{ height: height || 140, width: "auto" }}
      />
    );
  }
  const darkText = theme === "light";
  return (
    <div className={`flex items-center gap-2.5 ${className}`} aria-label="HO-SYS">
      <img
        src={iconSrc}
        alt="HO-SYS"
        draggable={false}
        className="shrink-0 select-none"
        style={{ height: height || 36, width: "auto" }}
      />
      {showText && (
        <span className="font-display font-extrabold text-xl tracking-tight leading-none">
          <span style={{ color: darkText ? "#111827" : "#DCE3EA" }}>HO-</span>
          <span style={{ color: "#2F7BFF" }}>SYS</span>
        </span>
      )}
    </div>
  );
}
